import React from 'react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { TextField, Button, Link, Snackbar, makeStyles } from '@material-ui/core';
import { Facebook, Instagram, LinkedIn, Twitter } from '@material-ui/icons';
import classes from './index.module.css';
import Axios from 'axios';
const useStyles = makeStyles({
    root: {
        background: 'linear-gradient(45deg, ##022aaf 30%, ##022aaf 90%)',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        color: 'white',
    },
    anchorOriginTopRight: {
        marginTop:'10vh',
        width:'300px'
    }
});
function Footer() {
    const [query, setQuery] = React.useState('idle');
    const [data, setData] = React.useState({ email: '', query: '' });
    const [open, setOpen] = React.useState(false);
    const Classes = useStyles();
    const handleData = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value,
        });
    }

    const submitQuery = async (event) => {
        event.preventDefault();
        setQuery('progress');
        try {
            await Axios.post("https://y3rzqzg5vg.execute-api.ap-south-1.amazonaws.com/dev/mail", {
                subject: 'Website Query Form',
                email: data.email,
                payload: {
                    email: data.email,
                    query: data.query
                }
            })
        } catch (e) {
            console.log(e);
            setQuery('failed');
            return;
        }
        setTimeout(() => {
            setData({email:'', query: ''});
            setQuery('idle');
            setOpen(true);
        }, 2000)
    }

    return (
        <div className={classes.footer}>
            <div className={classes.level1}>
                <div className={classes.imageContainer}>
                    <img className={classes.logo} src={`https://images.postplan.io/logo.png`} alt="logo" />
                </div>
                <div className={classes.level1Right}>
                    <div className={classes.socialIcons}>
                        <Link href="https://www.facebook.com/PostPlanApp" target="_blank">
                            <Facebook className={classes.socialIcon} />
                        </Link>
                        <Link href="https://twitter.com/PostPlanApp" target="_blank">
                            <Twitter className={classes.socialIcon} />
                        </Link>
                        <Link href="https://www.linkedin.com/company/post-plan" target="_blank">
                            <LinkedIn className={classes.socialIcon} />
                        </Link>
                        <Link href="https://www.instagram.com/postplan.app/?hl=en" target="_blank">
                            <Instagram className={classes.socialIcon} />
                        </Link>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', width: '60%', minWidth: '300px', padding: '10px' }}>
                        <form onSubmit={submitQuery}>
                            <TextField name="email" disabled={query === 'progress'} value={data.email} onChange={handleData} required margin="dense" fullWidth variant="outlined" label="Email" type="email" ></TextField>
                            <TextField name="query" disabled={query === 'progress'} value={data.query} onChange={handleData} required margin="dense" fullWidth variant="outlined" label="How can we help?" multiline rows={3} rowsMax={3}></TextField>
                            <Button variant="contained" type="submit" color="primary" disabled={query === 'progress'} classes={Classes} style={{ margin: '7px 0', width: '100%' }}>Submit</Button>
                        </form>
                    </div>
                </div>
            </div>
            <Divider />
            <Box pt={2} pb={6}>
                <div className={classes.level2}>
                    <div className={classes.terms}>
                        <span>
                            <Typography className={classes.caption1} variant="caption">
                                <Link variant="inherit" href="https://inventconsultancy.com/post-plan/terms-conditions.html" target="_blank">
                                    Terms & Conditions
                                </Link>
                            </Typography>
                        </span>
                        <span>
                            <Typography className={classes.caption1} variant="caption">
                                <Link variant="inherit" href="https://inventconsultancy.com/post-plan/privacy-policy.html" target="_blank">
                                    Privacy Policy
                                </Link>
                            </Typography>
                        </span>
                    </div>
                    <div className={classes.rightTerms}>
                        <div className={classes.storeBadges}>
                            <img className={classes.googleStoreIcon} src={`https://images.postplan.io/google-play-badge@2x.png`} alt="g" />
                            <img className={classes.appStoreIcon} src={`https://images.postplan.io/app-store.png`} alt="a" />
                        </div>
                        <div className={classes.comingSoon}>Coming Soon!</div>
                        {/* <Typography className={classes.caption2} variant="caption">Designed by Anonymous © Fake Studio 2020 All right reserved</Typography> */}
                    </div>
                </div>
                <Snackbar
                    classes={Classes}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    open={open}
                    onClose={()=>setOpen(false)}
                    message = {'We have got your query. We will get back to you soon.  \
                    You can do live chat with our support using the chat button on the bottom right corner of the screen'}
                    autoHideDuration={10000}
                    key={1}
                >
                </Snackbar>
            </Box>
        </div >
    )
}

export default Footer;